import type { Dispatch } from 'redux';
import type { BatchAction } from 'redux-batched-actions';
import { dismissFlagAction } from '../store/constants.tsx';
import type { Action } from '../store/types.tsx';
import { type DismissFlag, type FlagId, DISMISS_COMMAND } from '../types.tsx';

export const dismissFlag = (flagId: FlagId): DismissFlag => ({
	command: DISMISS_COMMAND,
	id: flagId,
});

const dismissFlagService = (dispatch: Dispatch<Action | BatchAction>) => (action: DismissFlag) => {
	dispatch(dismissFlagAction(action.id));
};

export default dismissFlagService;
